/* Байгууллага + салбар сонгох — нэвтэрсний дараах scope picker */
import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { authApi } from '@/api/auth';
import { auth } from '@/shared/auth/storage';
import { buildScopedPath, publicRoutes } from '@/app/routes';
import { IconChevronRight, IconDroplets } from '@/shared/icons';

export function SelectScopePage() {
  const nav = useNavigate();
  const [tenantId, setTenantId] = useState<string | null>(null);

  const tenantsQ = useQuery({
    queryKey: ['scope', 'tenants'],
    queryFn: authApi.myTenants,
    enabled: auth.isAuthed,
  });
  const companiesQ = useQuery({
    queryKey: ['scope', 'companies', tenantId],
    queryFn: () => authApi.companiesByTenant(tenantId!),
    enabled: !!tenantId,
  });

  if (!auth.isAuthed) return <Navigate to={publicRoutes.login} replace />;

  const tenants = tenantsQ.data ?? [];
  const companies = companiesQ.data ?? [];

  const pick = (cId: string) => {
    if (!tenantId) return;
    nav(buildScopedPath('queue', { tenantId, companyId: cId }), { replace: true });
  };

  return (
    <div className="h-screen overflow-y-auto bg-slate-100 font-sans">
      <div className="mx-auto max-w-[480px] p-6 flex flex-col gap-5">
        <div className="flex items-center gap-3 pt-6">
          <div className="w-10 h-10 rounded-[12px] bg-gradient-to-br from-[var(--brand1)] to-[var(--brand2)] flex items-center justify-center text-white">
            <IconDroplets size={22} strokeWidth={2.2} />
          </div>
          <div className="leading-tight">
            <div className="font-extrabold text-slate-900 text-[17px]">Carwash</div>
            <div className="text-[12px] text-slate-400 font-medium">Ажиллах байгууллагаа сонгоно уу</div>
          </div>
        </div>

        {/* Байгууллага */}
        <div className="flex flex-col gap-2">
          <div className="text-[11px] font-bold uppercase tracking-wide text-slate-400">Байгууллага</div>
          {tenants.map((t) => (
            <button key={t.Id} onClick={() => setTenantId(t.Id)}
              className={'w-full flex items-center gap-3 px-4 py-3.5 rounded-[var(--r)] ring-1 transition text-left ' +
                (tenantId === t.Id ? 'bg-cyan-50 ring-2 ring-[var(--brand2)]' : 'bg-white ring-slate-200 hover:ring-slate-300')}>
              <span className="text-[14px] font-bold text-slate-900 flex-1">{t.Name}</span>
              <IconChevronRight size={16} className="text-slate-300" />
            </button>
          ))}
          {tenantsQ.isLoading && <div className="text-[13px] text-slate-400 py-3 text-center">Ачааллаж байна…</div>}
          {!tenantsQ.isLoading && tenants.length === 0 && (
            <div className="text-[13px] text-slate-400 py-3 text-center">Таньд бүртгэлтэй байгууллага алга.</div>
          )}
        </div>

        {/* Салбар компани */}
        {tenantId && (
          <div className="flex flex-col gap-2">
            <div className="text-[11px] font-bold uppercase tracking-wide text-slate-400">Салбар</div>
            {companies.map((c) => (
              <button key={c.Id} onClick={() => pick(c.Id)}
                className="w-full flex items-center gap-3 px-4 py-3.5 rounded-[var(--r)] bg-white ring-1 ring-slate-200 hover:ring-2 hover:ring-[var(--brand2)] transition text-left">
                <span className="text-[14px] font-bold text-slate-900 flex-1">{c.Name}</span>
                <IconChevronRight size={16} className="text-slate-300" />
              </button>
            ))}
            {companiesQ.isLoading && <div className="text-[13px] text-slate-400 py-3 text-center">Ачааллаж байна…</div>}
            {!companiesQ.isLoading && companies.length === 0 && (
              <div className="text-[13px] text-slate-400 py-3 text-center">Энэ байгууллагад салбар алга.</div>
            )}
          </div>
        )}

        <button onClick={() => { auth.clear(); nav(publicRoutes.login, { replace: true }); }}
          className="self-start text-[13px] font-semibold text-slate-400 hover:text-slate-600 transition">
          Системээс гарах
        </button>
      </div>
    </div>
  );
}
